import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import { AccountContext } from "../accountContext";
import { Button } from "@mantine/core";
import SubscriptionProvider from "./subscriptionContext";
import SubscriptionCard from "./SubscriptionCard";

const useStyles = makeStyles((theme) => ({
  container: {
    "@media(max-width: 1024px)": {
      padding: "16px",
    },
  },
  pageInfo: {
    fontSize: "0.875rem",
    color: theme.app.secondaryColor,
    marginBottom: "2rem",
    marginTop: ".5rem",
  },
  linkContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(3,1fr)",
    gridGap: "16px",
    "@media(max-width: 667px)": {
      gridTemplateColumns: "1fr",
      gridGap: "8px",
    },
  },
  back: {
    marginTop: "2rem",
    borderTop: `1px solid ${theme.app.borderColor}`,
    padding: "8px 0",
  },
}));

const Subscription = () => {
  const classes = useStyles();
  const accountContext = useContext(AccountContext);
  const language = useSelector((state) => state.language);
  const { isSelf } = accountContext.state;

  const subscriptions =
    accountContext.state.accountData.member.subscriptionHistory;

  const sortedSubscriptions = subscriptions.sort(
    (a, b) => new Date(b.registrationDate) - new Date(a.registrationDate)
  );

  return (
    <div className={classes.container}>
      <Typography variant="h1">{language.Pages["subscription"]}</Typography>
      <Typography className={classes.pageInfo}>
        {language.PageInfo["subscription"]}
      </Typography>

      <div className={classes.linkContainer}>
        {sortedSubscriptions.map((sub) => {
          if (!isSelf) {
            return null;
          }
          return (
            <SubscriptionProvider
              subscriptionId={sub.subscriptionId}
              key={sub.subscriptionId}
            >
              <SubscriptionCard />
            </SubscriptionProvider>
          );
        })}
      </div>
      <div className={classes.back}>
        <Button
          className={classes.button}
          onClick={() => window.history.back()}
          color="dark"
          variant="subtle"
        >
          {language.Back}
        </Button>
      </div>
    </div>
  );
};

export default Subscription;
